import * as headSVG from './HeaderSVGs';
import * as homeSVG from './HomepageSVGs';
import * as CommunitySVG from './CommunitySVGs';
import * as AIIntroductionSVG from './AIIntroductionSVG';
import * as UseCaseSVG from './UseCaseSVGs';
import * as NewsLetterSVGs from './NewsLetterSVGs';
import * as EventsSVG from './EventsSVGs';
import * as AssistantsBot from './AssistantsBot';
import * as DataAIStrategy from './DataAIStrategy';
import * as DataTransformation from './DataTransformation';
import * as OpenDaySVG from './OpenDaySVG';
import * as TrainingCenter from './TrainingCenter';
import * as Background from './Background';
import * as ServicesSVGs from './ServicesSVGs';
import * as UserCenter from './UserCenter';
import * as Chanpionship from './Chanpionship';
import * as AiOpenDaySVG from './AiOpenDaySVG';
import * as Datapioneer from './Datapioneer';
export default {
  ...headSVG,
  ...homeSVG,
  ...CommunitySVG,
  ...NewsLetterSVGs,
  ...EventsSVG,
  ...UseCaseSVG,
  ...AIIntroductionSVG,
  ...AssistantsBot,
  ...DataAIStrategy,
  ...DataTransformation,
  ...OpenDaySVG,
  ...TrainingCenter,
  ...Background,
  ...ServicesSVGs,
  ...UserCenter,
  ...Chanpionship,
  ...AiOpenDaySVG,
  ...Datapioneer,
};
